// AUTO-GENERATED by `cargo xtask gen-manifest` - DO NOT EDIT

/** All available languages */
export const availableLanguages: string[] = [
  "ada",
  "agda",
  "asciidoc",
  "asm",
  "awk",
  "bash",
  "batch",
  "c",
  "c-sharp",
  "caddy",
  "capnp",
  "clojure",
  "cmake",
  "commonlisp",
  "cpp",
  "css",
  "d",
  "dart",
  "devicetree",
  "diff",
  "dockerfile",
  "dot",
  "elisp",
  "elixir",
  "elm",
  "erlang",
  "fish",
  "fsharp",
  "gleam",
  "glsl",
  "go",
  "graphql",
  "haskell",
  "hcl",
  "hlsl",
  "html",
  "idris",
  "ini",
  "java",
  "javascript",
  "jinja2",
  "jq",
  "json",
  "julia",
  "kdl",
  "kotlin",
  "lean",
  "lua",
  "markdown",
  "matlab",
  "meson",
  "nginx",
  "ninja",
  "nix",
  "objc",
  "ocaml",
  "perl",
  "php",
  "postscript",
  "powershell",
  "prolog",
  "python",
  "query",
  "r",
  "rescript",
  "ron",
  "ruby",
  "rust",
  "scala",
  "scheme",
  "scss",
  "sparql",
  "sql",
  "ssh-config",
  "starlark",
  "svelte",
  "swift",
  "textproto",
  "thrift",
  "tlaplus",
  "toml",
  "tsx",
  "typescript",
  "typst",
  "uiua",
  "vb",
  "verilog",
  "vhdl",
  "vim",
  "vue",
  "x86asm",
  "xml",
  "yaml",
  "yuri",
  "zig",
  "zsh",
];